/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import highlightjs from 'highlightjs';
import metrics from 'modules/metrics';
import container from 'modules/section-content';
import ContactForm from 'auth0-contact-form';
import Batch from 'batch';
import rg from 'modules/npm-component/require-global';
import React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { LockHomeDemo, LockPlaygroundHomepage } from 'components';
import layout from './home-page.pug';
import metadata from './data/metadata.json';

let unmountLockHeroDemo = () => {};
let unmountLockPlayground = () => {};

/**
 * Routes
 */
export default function register() {
  page('/', initial, loadScripts, snippets);
  page.exit('/', exit);
  page.exit('/signup', exit);
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(layout()) })
  };
  container.render(renderOptions);

  return next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/homepage/vendor/jquery-mobile-74ee4c679b.min.js', '$.fn.swiperight', done);
  });

  batch.end(next);
}

/**
 * Snippets
 */
function snippets(ctx, next) {
  unmountLockHeroDemo = renderLockHeroDemo();
  unmountLockPlayground = renderLockPlayground();

  popoverEmbedWistia();

  const $ = window.$;
  const carouselControls = $('[data-slide="prev"], [data-slide="next"], [data-slide-to]');

  // Load Roboto Mono Font
  loadRobotoFont();

  // Highlightjs

  highlightjs.configure({
    classPrefix: ''
  });

  $('pre code').each((i, block) => {
    highlightjs.highlightBlock(block);
  });

  rulesDemoAnimation();

  // Add css animation
  $('.carousel').bind('slide.bs.carousel', () => {
    $('.slides').addClass('animated');
  });

  // Track scroll until the widget is reached, then fire metrics event and unbind scroll
  $(window).on('scroll', trackScrollHomepage);

  // Track when carousel controls are clicked
  carouselControls.on('click', () => {
    metrics.lib().track('click:carousel');
  });

  $('#carousel').swiperight(function swiperight() {
    $(this).carousel('prev');
  });
  $('#carousel').swipeleft(function swipeleft() {
    $(this).carousel('next');
  });

  contactFormModals();

  next();
}

/**
 * Render lock hero demo
 */
function renderLockHeroDemo() {
  return renderReactComponent(<LockHomeDemo />, document.getElementById('hero-lock-demo'));
}

/**
 * Render playground lock
 */
function renderLockPlayground() {
  return renderReactComponent(
    <LockPlaygroundHomepage />,
    document.getElementById('playground-next')
  );
}

function renderReactComponent(instance, element) {
  let rendered = false;

  render(instance, element, setRenderedTrue);

  return unmounReactComponent;

  function setRenderedTrue() {
    rendered = true;
  }

  function unmounReactComponent() {
    if (rendered) {
      unmountComponentAtNode(element);
    }
  }
}

/**
 *  load popover embeds wistia Video
 */
function popoverEmbedWistia() {
  const popoverOptions =
    'autoPlay=true&controlsVisibleOnLoad=true&popover=true&version=v1&videoHeight=360&videoWidth=640';
  const hrefValue = `//fast.wistia.com/embed/iframe/fu7ww3h1yx?${popoverOptions}`;
  const addAttr = () => {
    $('#wistia-popover').on('click', false);
    return $('.video-btn').attr('href', hrefValue);
  };

  $.when(addAttr()).done(() => {
    $.getScript('//fast.wistia.com/static/popover-v1.js');
  });
}

/**
* Set carousel height
*/
function setCarouselHeight() {
  const $ = window.$;
  const windowHeight = $(window).height();
  const headerHeight = $('.site-header-v2').outerHeight(true);
  const customersHeight = $('.customers').outerHeight();
  $('.carousel').height(windowHeight - headerHeight - customersHeight);
}

/**
 * Load Roboto font
 */
function loadRobotoFont() {
  window.WebFontConfig = {
    google: { families: ['Roboto+Mono:400:latin'] }
  };
  (function webfont() {
    const wf = document.createElement('script');
    const s = document.getElementsByTagName('script')[0];
    wf.src = `${document.location.protocol === 'https:' ? 'https' : 'http'}://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js`;
    wf.type = 'text/javascript';
    wf.async = 'true';
    s.parentNode.insertBefore(wf, s);
  })();
}

/**
 * Track scroll on homepage when widget is reached
 */
function trackScrollHomepage() {
  const $ = window.$;
  const widgetOffsetTop = $('#playground-next').parent().parent().offset().top;
  const rulesOffset = $('.extensibility-example').parent().parent().offset().top;
  const rulesHeight = $('.extensibility-example').outerHeight(true);

  if ($(window).scrollTop() >= widgetOffsetTop) {
    metrics.lib().track('scroll:homepage');
  }

  if ($(window).scrollTop() >= rulesOffset && $(window).scrollTop() <= rulesOffset + rulesHeight) {
    $('.rules-animation').addClass('is-active');
  } else {
    $('.rules-animation').removeClass('is-active');
  }
}

/**
 *  // Contact Sales Form
 */
function contactFormModals() {
  const salesContactFormOptions = {
    onModalOpen() {
      window.metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      window.metricsLib.track('register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitSuccess('#contact-form-modal__form');
    },
    onFormFail(metricsData) {
      window.metricsLib.track('fail:register:lead:homepage-contact-form', metricsData);
      if (window.mouseFlow) window.mouseFlow.formSubmitFailure('#contact-form-modal__form');
    },
    source: 'home-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  $('.open-contact-form-modal').click(() => salesContactForm.show({ includePhoneField: true }));
}

/**
 * Unsubscribe from window events
 */
function exit(ctx, next) {
  const $ = window.$;
  $(window).off('scroll', trackScrollHomepage);
  $(window).off('resize', setCarouselHeight);

  unmountLockHeroDemo();
  unmountLockPlayground();

  next();
}

/**
 * show animation a/b - experiments
 */

window.animationExperiment = () => {
  const $ = window.$;
  const vid = document.getElementById('why-video');

  function playVid() {
    vid.play();
  }

  $('a.play-me-again').on('click', e => {
    e.preventDefault();

    if (window.wistiaJQuery) playVid();
  });
};

/* Select */

const ruleTemplates = {};

ruleTemplates.option1 = `function (user, context, callback) {
  if (context.clientName === 'TheAppToCheckAccessTo') {
    var d = new Date().getDay();
      if (d === 0 || d === 6) {
        return callback(new UnauthorizedError('This app is available during the week'));
    }
  }
  callback(null, user, context);
}`;

ruleTemplates.option2 = `function(user, context, callback) {
  // short-circuit if the user signed up already
  if (context.stats.loginsCount > 1) return callback(null, user, context);

  // get your slack's hook url from: https://slack.com/services/10525858050
  var SLACK_HOOK = 'YOUR SLACK HOOK URL';

  var slack = require('slack-notify')(SLACK_HOOK);
  var message = 'New User: ' + (user.name || user.email) + ' (' + user.email + ')';
  var channel = '#some_channel';

  slack.success({
   text: message,
   channel: channel
  });

  // don’t wait for the Slack API call to finish, return right away (the request will continue on the sandbox)
  callback(null, user, context);
}`;

ruleTemplates.option3 = `function (user, context, callback) {
    var whitelist = ['1.2.3.4', '2.3.4.5']; //authorized IPs
    var userHasAccess = whitelist.some(
      function (ip) {
        return context.request.ip === ip;
      });

    if (!userHasAccess) {
      return callback(new UnauthorizedError('Access denied from this IP address.'));
    }

    return callback(null, user, context);
}`;

function rulesDemoAnimation() {
  $('#ruleOptions').change(function rulesDemoAnimationOnChange() {
    const selected = $(this).val();

    $('.rule-editor pre code').empty();

    $('.rule-editor pre code').append(ruleTemplates[selected]);

    $('pre code').each((i, block) => {
      highlightjs.highlightBlock(block);
    });
  });
}



// WEBPACK FOOTER //
// ./src/pages/ab-variants/new-homepage/client.js